import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/TopBar';
import { useAuth } from '../context/AuthContext';

const DashboardLayout = () => {
  // Desktop: sidebar collapsed/expanded. Mobile: sidebar hidden/drawer.
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isReadOnly } = useAuth();

  // Toggle a body attribute so global CSS can hide write-actions when
  // the current user is in read-only mode (see App.css `.ro-hide`).
  useEffect(() => {
    if (isReadOnly) document.body.setAttribute('data-app-readonly', 'true');
    else document.body.removeAttribute('data-app-readonly');
    return () => document.body.removeAttribute('data-app-readonly');
  }, [isReadOnly]);

  const toggle = () => {
    // Use mobile drawer on small screens, collapse on desktop
    if (window.innerWidth < 1024) {
      setMobileOpen((v) => !v);
    } else {
      setCollapsed((v) => !v);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />

      {/* Mobile backdrop */}
      {mobileOpen && (
        <button
          aria-label="Chiudi menu"
          onClick={() => setMobileOpen(false)}
          className="fixed inset-0 z-30 bg-black/40 lg:hidden"
        />
      )}

      <div
        className={`transition-all duration-300 ${
          collapsed ? 'lg:pl-16' : 'lg:pl-64'
        } pl-0`}
      >
        <TopBar onToggleSidebar={toggle} />
        <main className="p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
